import { azureCostService } from "../services/azureCost.service";
import { azureCostConstants } from "../constants/azureCost.constants";

export const azureCostActions = {
  get,
  getById,
  create,
  update,
  remove,
  bulkUpsert,
  getDaily,
  getMonthly,
  getQuarterly,
  getSubscriptions,
  getChartData,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    azureCostService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: azureCostConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: azureCostConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_FAILURE };
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request(id));

    azureCostService.getById(id).then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(id) {
    return {
      type: azureCostConstants.GET_BY_ID_REQUEST,
      payload: id,
    };
  }
  function success(cost) {
    return {
      type: azureCostConstants.GET_BY_ID_SUCCESS,
      payload: cost,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_BY_ID_FAILURE };
  }
}

function create(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    azureCostService.create(requestBody).then(
      () => {
        dispatch(success());
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestBody) {
    return {
      type: azureCostConstants.CREATE_REQUEST,
      payload: requestBody,
    };
  }
  function success() {
    return { type: azureCostConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: azureCostConstants.CREATE_FAILURE };
  }
}

function update(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    azureCostService.update(requestBody).then(
      () => {
        dispatch(success());
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestBody) {
    return {
      type: azureCostConstants.UPDATE_REQUEST,
      payload: requestBody,
    };
  }
  function success() {
    return { type: azureCostConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: azureCostConstants.UPDATE_FAILURE };
  }
}

function remove(id) {
  return (dispatch) => {
    dispatch(request(id));

    azureCostService.remove(id).then(
      () => {
        dispatch(success());
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(id) {
    return {
      type: azureCostConstants.DELETE_REQUEST,
      payload: id,
    };
  }
  function success() {
    return { type: azureCostConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: azureCostConstants.DELETE_FAILURE };
  }
}

function bulkUpsert(costs) {
  return (dispatch) => {
    dispatch(request(costs));

    azureCostService.bulkUpsert(costs).then(
      () => {
        dispatch(success());
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(costs) {
    return {
      type: azureCostConstants.BULK_UPSERT_REQUEST,
      payload: costs,
    };
  }
  function success() {
    return { type: azureCostConstants.BULK_UPSERT_SUCCESS };
  }
  function failure() {
    return { type: azureCostConstants.BULK_UPSERT_FAILURE };
  }
}

function getDaily(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    azureCostService.getDaily(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: azureCostConstants.GET_DAILY_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: azureCostConstants.GET_DAILY_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_DAILY_FAILURE };
  }
}

function getMonthly(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    azureCostService.getMonthly(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: azureCostConstants.GET_MONTHLY_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: azureCostConstants.GET_MONTHLY_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_MONTHLY_FAILURE };
  }
}

function getQuarterly(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    azureCostService.getQuarterly(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: azureCostConstants.GET_QUARTERLY_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: azureCostConstants.GET_QUARTERLY_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_QUARTERLY_FAILURE };
  }
}

function getSubscriptions() {
  return (dispatch) => {
    dispatch(request());

    azureCostService.getSubscriptions().then(
      (response) => {
        dispatch(success(response.data));
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: azureCostConstants.GET_SUBSCRIPTIONS_REQUEST,
    };
  }
  function success(subscriptions) {
    return {
      type: azureCostConstants.GET_SUBSCRIPTIONS_SUCCESS,
      payload: subscriptions,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_SUBSCRIPTIONS_FAILURE };
  }
}

function getChartData(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    // Fetch all three datasets in parallel for charts
    Promise.all([
      azureCostService.getDailyForChart(requestParameters),
      azureCostService.getMonthlyForChart(requestParameters),
      azureCostService.getQuarterlyForChart(requestParameters),
    ]).then(
      ([dailyResponse, monthlyResponse, quarterlyResponse]) => {
        dispatch(
          success({
            daily: dailyResponse.data?.data || [],
            monthly: monthlyResponse.data?.data || [],
            quarterly: quarterlyResponse.data?.data || [],
          })
        );
      },
      () => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: azureCostConstants.GET_CHART_DATA_REQUEST,
    };
  }
  function success(chartData) {
    return {
      type: azureCostConstants.GET_CHART_DATA_SUCCESS,
      payload: chartData,
    };
  }
  function failure() {
    return { type: azureCostConstants.GET_CHART_DATA_FAILURE };
  }
}
